
import './style.scss';

import { useCallback } from 'react';
import { Avatar, Box, Grid, IconButton } from '@mui/material';
import { Add, Logout, Menu, MenuOpen } from '@mui/icons-material';
import { StartLink } from '../../data/Navigation';
import { useNavigationContext } from '../../contexts/NavigationContext';
import Navigation from '../Navigation';
import { useEnvironmentContext } from '../../contexts/EnvironmentContext';
import LogoutDialog from './LogoutDialog';
import { useLanguageContext } from '../../contexts/LanguageContext';
import NavigationLink from './NavigationLink';
import ProfileMenu from '../ProfileMenu';
import { useUserContext } from '../../contexts/UserContext';
import NavigationHelper from '../../helpers/NavigationHelper';
import useDialog from '../../hooks/useDialog';
import useDrawer from '../../hooks/useDrawer';


const AppBar = () => {
    const { environment } = useEnvironmentContext();
    const { translate } = useLanguageContext();
    const { user, userPermissions, enterprise } = useUserContext();
    const { selectedNavigationLink, setSelectedNavigationLink } = useNavigationContext();

    const navigation = useDrawer();
    const profileMenu = useDialog();
    const preferencesDialog = useDialog();
    const logoutDialog = useDialog();

    
    const createShortcuts = useCallback(() => {
        const enterpriseShortcuts = user?.enterprises.find(e => e.id === enterprise?.id)?.shortcuts.map(s => {
            const alias = s.alias.split('.');
            return `${alias[0]}.${alias[1]}`;
        }) ?? [];

        const shortcuts = NavigationHelper
            .FilterItems(n => userPermissions.includes(n.alias[0]) && enterpriseShortcuts.includes(n.alias[0]))
            .map((n, index) => {
                const Icon = n.Icon;

                return <NavigationLink 
                    name={translate(n.name)} 
                    Icon={Icon} 
                    onClick={() => setSelectedNavigationLink(n)} 
                    selected={selectedNavigationLink === n}
                    key={index}
                />;
            });

        if (shortcuts.length > 0) {
            return shortcuts;
        }

        return <NavigationLink 
            name={translate('addShortcuts')} 
            Icon={Add} 
            onClick={() => preferencesDialog.handleOpen()}
            className='width-100pc'
        />;

        // eslint-disable-next-line
    }, [user, userPermissions, enterprise, translate, selectedNavigationLink]);

    return (
        <>
            <Box component={Grid} container className={`appbar-admin`}>
                <Grid item className='grid-icon'>
                    <img 
                        src={environment.partnerPms.images.icon} 
                        alt={environment.partnerPms.description} 
                        className='icon' 
                        onClick={() => setSelectedNavigationLink(StartLink)} 
                    />

                    <img 
                        src={environment.partnerPms.images.logoHorizontal} 
                        alt={environment.partnerPms.description} 
                        className='icon full' 
                        onClick={() => setSelectedNavigationLink(StartLink)} 
                    />
                </Grid>
                
                <Grid item className='grid-menu'>
                    <IconButton size="medium" className='iconbutton-action' onClick={() => navigation.handleOpen()}>
                        {navigation.open ? <MenuOpen fontSize='medium' /> : <Menu fontSize='medium' />}
                    </IconButton>
                </Grid>

                <Grid item className='grid-navigation'>
                    {createShortcuts()}
                </Grid>

                <Grid item className='grid-footer'>
                    <IconButton size="medium" className='iconbutton-action iconbutton-logout' onClick={() => logoutDialog.handleOpen()}>
                        <Logout fontSize='medium' />
                    </IconButton>

                    <Avatar 
                        alt={user?.fullName.toUpperCase()} 
                        src={user?.avatar}
                        className='avatar-user'
                        onClick={() => profileMenu.handleOpen()}
                    />
                </Grid>
            </Box>

            <Navigation
                open={navigation.open}
                handleClose={() => navigation.handleClose()}
            />

            <ProfileMenu 
                open={profileMenu.open}
                handleClose={() => profileMenu.handleClose()}
                handleOpenLogoutDialog={() => logoutDialog.handleOpen()}
                openPreferences={preferencesDialog.open}
                handleClosePreferences={() => preferencesDialog.handleClose()}
            />

            <LogoutDialog
                title={translate('logout')}
                open={logoutDialog.open} 
                handleClose={() => logoutDialog.handleClose()}
            />
        </>
    );
}


export default AppBar;